import React from 'react';
import { Home } from './home';

export const App = () => <div className="App"><Home/></div>;
